import { component } from 'picoapp'
import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

export default component((node) => {
    const url = node.dataset.url

    const fetchProducts = () => {
        fetch(url)
            .then((res) => res.text())
            .then((data) => {
                const container = document.createElement('div')
                container.innerHTML = data

                clear(node)
                node.insertAdjacentHTML('beforeend', container.querySelector('[data-component]').innerHTML)
            })
            .then(() => {
                const sliderElem = node.querySelector('[data-slider]')
                new Swiper(sliderElem, {
                    slidesPerView: 1,
                    spaceBetween: 5,
                    breakpoints: {
                        // when window width is >= 320px
                        740: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 480px
                        1200: {
                            slidesPerView: 3,
                        },
                        // when window width is >= 640px
                        1840: {
                            slidesPerView: 4,
                        },
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                })
            })
    }

    function clear(node) {
        while (node.firstChild) {
            node.removeChild(node.firstChild)
        }
    }

    fetchProducts()
})
